<template>
  <div class="form-select" :style="style">
    <span @click="inputClick" v-if="$store.state.assigningIndexes" class="tab-index" :style="tabOrderStyle">
      {{ ($store.getters.templateTabOrder(id) > -1) ? $store.getters.templateTabOrder(id) : '?' }}
    </span>
    <select
      class="input-select"
      @click="focusInput"
      :id="id"
      :style="inputStyle"
      @contextmenu="inputClick"
      :tabindex="$store.getters.templateTabOrder(id)"
      :data-model="model"
    >
      <option v-for="(option, index) in options" :key="index">
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
  import mixinEditor from '@/mixins/editor.js'

  export default {
    name: 'form-select',

    mixins: [mixinEditor],

    props: [
      'id',
      'width',
      'height',
      'left',
      'top',
      'options',
      'model'
    ],

    methods: {
      inputClick (e) {
        e.preventDefault()
        this.$bus.emit('openFieldMenu', {
          id: this.id,
          pos: { x: e.pageX, y: e.pageY },
          tabOrder: this.tabOrder
        })
      },

      focusInput () {
        this.$bus.emit('scrollToElement', this.id)
      }
    },

    computed: {
      style () {
        let styleStr = 'position: absolute;'
        styleStr += 'width: ' + this.width + 'px;'
        styleStr += 'height: ' + this.height + 'px;'
        styleStr += 'left: ' + this.left + 'px;'
        styleStr += 'top: ' + this.top + 'px;'
        styleStr += 'font-size: ' + 12 * this.$store.state.pageScale + 'px;'
        return styleStr
      },

      tabOrderStyle () {
        let tabStyleStr = ''
        tabStyleStr += 'width: ' + 20 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'height: ' + 20 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'font-size: ' + 14 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'left: -' + 25 * this.$store.state.pageScale + 'px;'
        return tabStyleStr
      },

      inputStyle () {
        return this.model !== '' && this.listOfficialModels.length > 0 && this.listOfficialModels.map(a => a.model).indexOf(this.model) === -1 ? 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;outline:red solid 1px;' : 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tab-index {
    user-select: none;
    position: absolute;
    top: 0;
    min-width: 22px;
    min-height: 22px;
    background-color: #5E738B;
    border: 2px solid #333;
    color: #FFF;
    text-align: center;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    z-index: 10;

    &:hover {
      outline: 3px dashed blue;

      &+select {
        outline: 2px dashed blue;
      }
    }
  }

  select {
    user-select: none;
    width: 100%;
    height: 100%;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    background-color: #FFF;

    &:hover {
      outline: green solid 3px;
    }

    &:before {
      content: " ";
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/editor/inputs/FormSelect.vue